export default __webpack_public_path__ + "assets/icons/asknow-signet.svg";